/* eslint-disable max-len */
const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;

export const HELPING_MESSAGE = 'Helping you get the most from BT:';
export const LOGIN_LABEL = 'Log in to My Account';
export const LOGIN_PATH = `${REACT_APP_MY_ACCOUNT_DOMAIN}/Hub`;
export const REGISTRATION_LABEL = 'Register for My Account';
export const REGISTRATION_PATH = `${REACT_APP_MY_ACCOUNT_DOMAIN}/registration`;
export const CHECK_BILLING_INFO_LABEL = 'Check billing information';
export const CHECK_BILLING_INFO_PATH = `${REACT_APP_MY_ACCOUNT_DOMAIN}/eserve/cust/loggedin/hub.html`;
export const SET_UP_DIRECT_DEBIT_LABEL = 'Set up Direct Debit';
export const SET_UP_DIRECT_DEBIT_PATH = `${REACT_APP_MY_ACCOUNT_DOMAIN}/eserve/cust/loggedin/setupDDMultiDetails.html?dl=true`;
export const INSTALL_ANTIVIRUS_LABEL = 'Install antivirus protection';
export const INSTALL_ANTIVIRUS_PATH =
  'https://business.bt.com/help/article/email-security-and-hosting/online-safety-and-security/how-to-install-business-antivirus-protection/';
export const KEEP_YOUR_BUSINESS_SAFE_LABEL = 'Keep your business safe';
export const KEEP_YOUR_BUSINESS_SAFE_PATH =
  'https://business.bt.com/help/article/email-security-and-hosting/online-safety-and-security/using-bt-content-controls/';

export const anonymousLinkList = [
  [
    { label: LOGIN_LABEL, link: LOGIN_PATH },
    { label: REGISTRATION_LABEL, link: REGISTRATION_PATH },
  ],
];

export const authLinkList = [
  [
    { label: CHECK_BILLING_INFO_LABEL, link: CHECK_BILLING_INFO_PATH },
    { label: SET_UP_DIRECT_DEBIT_LABEL, link: SET_UP_DIRECT_DEBIT_PATH },
  ],
  [
    { label: INSTALL_ANTIVIRUS_LABEL, link: INSTALL_ANTIVIRUS_PATH },
    { label: KEEP_YOUR_BUSINESS_SAFE_LABEL, link: KEEP_YOUR_BUSINESS_SAFE_PATH },
  ],
];
